var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultOfficialAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EFF3F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-official-account_svg__clip0_24008_95087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 31.729L49.999 13 82 31.726 49.993 50.537 18 31.729z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.993 50.537L18 31.729v37.42L49.993 88V50.538z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.993 50.537L18 31.729v37.42l31.993-18.612z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.997 50.537l31.994-18.808v37.42L49.992 88l.005-37.462z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50.537l31.993-18.808v37.42L50 50.537z",
    fill: "#D6D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.086 40.01l17.91-10.483 18.032 10.554L49.99 50.686 32.087 40.01z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.996 50.537L32.086 40.01v25.993l10.466 5.87 7.444-4.398V50.537z",
    fill: "#D6D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.993 63.523l-7.43-4.215v12.517l7.43-4.35v-3.952z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.992 50.537L67.9 40.01v25.993l-10.463 5.87-7.444-4.398V50.537z",
    fill: "#E8ECF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.992 63.523l7.431-4.215v12.517l-7.43-4.35v-3.952z",
    fill: "#D6D9E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-official-account_svg__clip0_24008_95087"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(18 13)",
    d: "M0 0h64v75H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjUwIiBmaWxsPSIjRUZGM0Y4Ii8+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNDAwOF85NTA4NykiPgo8cGF0aCBkPSJNMTggMzEuNzI4OEw0OS45OTg3IDEzTDgyIDMxLjcyNjJMNDkuOTkzNSA1MC41MzdMMTggMzEuNzI4OFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00OS45OTM1IDUwLjUzNjdMMTggMzEuNzI4NVY2OS4xNDkxTDQ5Ljk5MzUgODcuOTk5N1Y1MC41MzY3WiIgZmlsbD0iI0Y3RjhGQSIvPgo8cGF0aCBkPSJNNDkuOTkzNSA1MC41MzY3TDE4IDMxLjcyODVWNjkuMTQ5MUw0OS45OTM1IDUwLjUzNjdaIiBmaWxsPSIjRThFQ0YyIi8+CjxwYXRoIGQ9Ik00OS45OTc0IDUwLjUzNjdMODEuOTkwOSAzMS43Mjg1VjY5LjE0OTFMNDkuOTkyMiA4Ny45OTk3TDQ5Ljk5NzQgNTAuNTM2N1oiIGZpbGw9IiNGN0Y4RkEiLz4KPHBhdGggZD0iTTUwIDUwLjUzNjdMODEuOTkzNSAzMS43Mjg1VjY5LjE0OTFMNTAgNTAuNTM2N1oiIGZpbGw9IiNENkQ5RTMiLz4KPHBhdGggZD0iTTMyLjA4NTkgNDAuMDA5OUw0OS45OTU3IDI5LjUyNzNMNjguMDI3OSA0MC4wODEzTDQ5Ljk5MDUgNTAuNjg1NkwzMi4wODU5IDQwLjAwOTlaIiBmaWxsPSIjRjdGOEZBIi8+CjxwYXRoIGQ9Ik00OS45OTU3IDUwLjUzNzNMMzIuMDg1OSA0MC4wMDk4VjY2LjAwMzFMNDIuNTUxOCA3MS44NzI5TDQ5Ljk5NTcgNjcuNDc0NVY1MC41MzczWiIgZmlsbD0iI0Q2RDlFMyIvPgo8cGF0aCBkPSJNNDkuOTkzNSA2My41MjM0TDQyLjU2MjUgNTkuMzA3NlY3MS44MjUzTDQ5Ljk5MzUgNjcuNDc0NVY2My41MjM0WiIgZmlsbD0iI0U4RUNGMiIvPgo8cGF0aCBkPSJNNDkuOTkyMiA1MC41MzczTDY3Ljg5OTQgNDAuMDA5OFY2Ni4wMDMxTDU3LjQzNjIgNzEuODcyOUw0OS45OTIyIDY3LjQ3NDVWNTAuNTM3M1oiIGZpbGw9IiNFOEVDRjIiLz4KPHBhdGggZD0iTTQ5Ljk5MjIgNjMuNTIzNEw1Ny40MjMyIDU5LjMwNzZWNzEuODI1M0w0OS45OTIyIDY3LjQ3NDVWNjMuNTIzNFoiIGZpbGw9IiNENkQ5RTMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDAwOF85NTA4NyI+CjxyZWN0IHdpZHRoPSI2NCIgaGVpZ2h0PSI3NSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4IDEzKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgDefaultOfficialAccount as ReactComponent };